import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"

function SpIntroduction() {
  const data = useStaticQuery(graphql`
    query {
      sp_UNFILTER_information: file(
        relativePath: { eq: "sp_UNFILTER_information.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <>
      <Box width="100%" textAlign="center" padding="92px 0" bgcolor="#ffffff">
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          style={{ backgroundColor: "#ffffff" }}
        >
          <Box padding="0 0 17px">
            <WrapTypo fs="14px">“ありのままの美しさを継続させる”</WrapTypo>
          </Box>
          <Box width="59%" maxWidth="240.55px" padding="0 0 34px">
            <Img fluid={data.sp_UNFILTER_information.childImageSharp.fluid} />
          </Box>
          <Box padding="0 0 11px" mb={"3%"}>
            <WrapTypo fs="11px" lh="200%">
              私たちはただ肌を美しくするだけではなく、
              <br />
              心に安らぎと高揚感をえながら
              <br />
              本当に続けることができる美容に着目しました。
              <br />
            </WrapTypo>
          </Box>
          <Box padding="0 0 11px" mb={"3%"}>
            <WrapTypo fs="11px" lh="200%">
              「ありのままの美しさを継続させる」
              <br />
              をコンセプトに美容商品開発に
              <br />
              取り組ませていただいております。
            </WrapTypo>
          </Box>
          <Box padding="0 0 11px" mb={"3%"}>
            <WrapTypo fs="11px" lh="200%">
              自分と向き合う時間が増えたこの時代
              <br />
              知らない間に自分の中に
              <br />
              フィルターは増えるもの。
              <br />
              綺麗になりたい。変わりたいと
              <br />
              思っていても
              <br />
              何から始めていいかわからない
            </WrapTypo>
          </Box>
          <Box padding="0 0 11px">
            <WrapTypo fs="11px" lh="200%">
              まずは、UNFILTERをそっとお風呂に
              <br />
              入れてみることから
            </WrapTypo>
            <WrapTypo fs="11px" lh="200%">
              自分のペースでゆったりと始めることができるように
            </WrapTypo>
          </Box>
          <Box mb={"3%"}>
            <WrapTypo fs="11px" lh="200%">
              美容トリートメントバスオイル
              <br />
              「UNFILTER」のプログラムを作りました。
            </WrapTypo>
          </Box>
        </Grid>
      </Box>
    </>
  )
}

export default SpIntroduction
